import { CSSProperties } from "react";
import { Button, Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
const { Item } = Form;

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  .divider {
    background-color: ${(props) => props.theme["@avatar-background"]};
  }
`;

export const LabelCarrier = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  font-family: ${(props) => props.theme["@font-family"]};
  .truckEntryIcon {
    color: ${(props) => props.theme["@neutral-600"]};
  }
`;

export const LabelInfo = styled.div`
  margin-left: 10px;
  align-items: center;
  font-family: ${(props) => props.theme["@font-family"]};
`;

export const LabelInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin: 22px 0;
  font-family: ${(props) => props.theme["@font-family"]};
  .truckIcon,
  .documentIcon,
  .processIcon {
    color: ${(props) => props.theme["@neutral-600"]};
  }
  .documentItem {
    margin: 0;
  }
`;

export const LabelItemDescription = styled.div`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  text-transform: uppercase;
  font-family: ${(props) => props.theme["@font-family"]};
  color: ${(props) => props.theme.colors.text};
`;

export const Divider: CSSProperties = {
  height: "100vh",
};

export const LabelCarrierDescription = styled.div`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  max-width: 330px;
  font-family: ${(props) => props.theme["@font-family"]};
  color: ${(props) => props.theme.colors.text};
  line-break: anywhere;
`;

export const TitleItem: CSSProperties = {
  fontSize: theme["@medium-font-size"],
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  color: theme["@neutral-600"],
};

export const LabelProcessDescription = styled.div`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  max-width: 330px;
  font-family: ${(props) => props.theme["@font-family"]};
  color: ${(props) => props.theme["@neutral-600"]};
  line-break: anywhere;
`;

export const LabelObservationDescription = styled.div`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-family: ${(props) => props.theme["@font-family"]};
  color: ${(props) => props.theme["@neutral-600"]};
  line-break: anywhere;
`;

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};

    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    color: ${(props) => props.theme["@neutral-600"]};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }

  .ant-input-affix-wrapper > input.ant-input {
    text-transform: uppercase;
  }

  .ant-form-item-control-input-content > textarea {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    &:hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
    }
  }
`;

export const FormAddPlate = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  margin-bottom: -20px;

  .ant-form-item-label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    padding: 0;
  }

  .ant-form-item-control-input-content {
    color: ${(props) => props.theme["@primary-color-brand"]};
    width: 31%;
    display: flex;
    align-items: center;
  }
`;

export const AddButtonPlate = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  float: left;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.colors.text};
  :hover,
  :focus {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .addButtonTrailersPlates {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const TrailersPlatesField: CSSProperties = {
  width: "132px",
  marginRight: "3px",
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
};

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const TitleForm: CSSProperties = {
  color: theme.colors.text,
  fontSize: "18px",
};

export const ProcessesSelect: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  fontSize: theme["@medium-font-size"],
  fontWeight: theme["@normal-font-weight"],
};

export const ProcessesFormItem: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  marginBottom: "61px",
};

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};
